import React from 'react';
import '../i18n';
import { useTranslation } from 'react-i18next';
import Card from './Card';

const Main = (props) => {
    const { t } = useTranslation();

    const getCurrentBgImage = () => {
        if (props.data.params) {
            return `url(${props.data.settings.background_image_url || props.data.settings.organization_background_image_url || ''})`;
        }
    }

    const getCurrentBgColor = () => {
        if (props.data.params) {
            return props.data.settings.background_color || props.data.settings.organization_background_color || '#fff';
        }
    }

    return (
        <main
            className="flex overflow-auto flex-1 bg-fixed bg-cover bg-no-repeat w-screen items-center justify-center"
            style={{ backgroundImage: getCurrentBgImage(), backgroundColor: getCurrentBgColor() }}
        >
            <div className="wrapper relative xl:w-3/4 2xl:w-2/3 lg:w-3/4 sm:">
                <div className="justify-center ml-auto mr-auto">
                    <ul id="container" className="flex flex-wrap justify-center pl-0" style={{ minHeight: '67vh', alignItems: 'flex-start' }}>
                        {props.eventsFiltered.length ? (props.eventsFiltered.map((event) => {
                            return (
                                <React.Fragment>
                                    <Card event={event} params={props.data.params} settings={props.data.settings} categories={props.data.categories} />
                                </React.Fragment>
                            );
                        })) : <div className="flex rounded-lg bg-white p-2">{t('no_result')}</div>}
                    </ul>
                </div>
            </div>
        </main>
    )
}

export default Main;